import { useMemo } from 'react';

interface TimeAgoProps {
  timestamp: string;
  className?: string;
  showTooltip?: boolean;
}

function formatTimeAgo(timestamp: string): string {
  const now = new Date();
  const then = new Date(timestamp);
  const diffMs = now.getTime() - then.getTime();
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSecs < 60) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return then.toLocaleDateString();
}

function formatFullDate(timestamp: string): string {
  const date = new Date(timestamp);
  return date.toLocaleString(undefined, {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export default function TimeAgo({
  timestamp,
  className = '',
  showTooltip = true,
}: TimeAgoProps) {
  const timeAgo = useMemo(() => formatTimeAgo(timestamp), [timestamp]);
  const fullDate = useMemo(() => formatFullDate(timestamp), [timestamp]);

  return (
    <time
      dateTime={timestamp}
      title={showTooltip ? fullDate : undefined}
      className={`text-gray-500 ${className}`}
    >
      {timeAgo}
    </time>
  );
}
